export default __webpack_public_path__ + "static/cp-app-screens-mobile-95315bb787465fcf3fd2f59c1a1a0a7d.jpg";